import * as React from "react";
import "./AedasLoading.css";
export default function AedasLoading() {
  return (
    <div className="d-flex justify-content-center">
      <div className="lds-dual-ring"></div>
    </div>
  );
}
